import React, { useState, useEffect } from 'react'
import { FetchReadIncomingTransactions, FetchArticleTypeImages, FetchApproveCorrection } from '../../../fetcher';
import AlertMessage from '../../alertmessages/AlertMessageView';
import { ModalView } from '../../_reusedcomponents/ModalView';
import { useHandleAlertMessage } from '../../../utils/togglinghooks';
import { CorrectionContainer } from '../../corrections/CorrectionContainer';

/**
 * IMPORTANT:
 * Needs to be refactored. Way too many useStates and functions are passed into IncomingTransactionsTableContainer.
 */
const IncomingTransactionsContainer = () => {

    const { showAlertMessage, openAlert, closeAlert } = useHandleAlertMessage()
    const [alertMessage, setAlertMessage] = useState("")

    const [incomingTransactions, setIncomingTransactions] = useState([])
    const [articleDataReady, setArticleDataToReady] = useState(false)

    const [showConfirmationModal, setShowConfirmationModel] = useState(false)
    const [confirmTransactionSysId, setTransactionSysId] = useState("")
    const [confirmTransactionState, setTransactionState] = useState("")

    const [modalTitle, setModalTitle] = useState("")
    const [modalDescription, setModalDescription] = useState("")

    const handleCloseConfirmationModal = () => setShowConfirmationModel(false)

    const addingImages = (articleTypeImages) => {
        let copiedIncomingTransactions = [...incomingTransactions]
        articleTypeImages.forEach(image => copiedIncomingTransactions.flatMap(x => x.Articles).filter(x => x.ArticleTypeSysId == image.ArticleTypeSysId).forEach(xfiltered => xfiltered.Image = 'data:image/png;base64,' + image.Data))
        setIncomingTransactions(copiedIncomingTransactions)
    }

    const handleSetIncomingTransactions = (transactions) => {
        setIncomingTransactions(transactions.filter(x => x.Type != "NewArrivals" && x.Type != "CorrectionForNewArrivals" && x.State != "Confirmed"))
    }

    useEffect(() => {
        FetchReadIncomingTransactions(handleSetIncomingTransactions, openAlert, setArticleDataToReady)
    }, []);

    useEffect(() => {
        if (articleDataReady) {
            FetchArticleTypeImages(incomingTransactions.flatMap(x => x.Articles).map(x => x.ArticleTypeSysId.toString()), addingImages, openAlert)
        }
    }, [articleDataReady])

    const reload = () => {
        FetchReadIncomingTransactions(handleSetIncomingTransactions, openAlert, setArticleDataToReady)
    }

    const handleApproveTransaction = () => {
        if (confirmTransactionSysId != "") {
            const stateChangeModel = {
                AbstractTransactionSysId: confirmTransactionSysId,
                OldState: confirmTransactionState,
                NewCorrections: incomingTransactions.filter(x => x.TransactionSysId == confirmTransactionSysId)[0].Articles
            };

            //setNewCorrections([])
            FetchApproveCorrection(stateChangeModel, handleCloseConfirmationModal, reload, openAlert)
        }
    }

    return (
        <>
            <CorrectionContainer incomingTransactions={incomingTransactions}
                setAlertMessage={setAlertMessage} setModalTitle={setModalTitle} setModalDescription={setModalDescription}
                setTransactionSysId={setTransactionSysId} setTransactionState={setTransactionState} openAlert={openAlert} setShowConfirmationModel={setShowConfirmationModel}/>

            <ModalView handleShow={showConfirmationModal} handleClose={handleCloseConfirmationModal} handleSubmit={handleApproveTransaction}
                reload={reload} modalTitle={modalTitle} modalBody={modalDescription} />

            <AlertMessage showAlertMessage={showAlertMessage} closeAlert={closeAlert} message={alertMessage} />
        </>
    )
}

export { IncomingTransactionsContainer }
